/**
 * Home page links configuration
 */

export interface HomeLink {
  url: string;
  label: string;
}

export const homeLinks: HomeLink[] = [
  {
    url: 'https://github.com/Slalom',
    label: 'Slalom GitHub',
  },
  {
    url: 'https://aws.slalom.com',
    label: 'AWS Innovation Lab',
  },
  {
    url: 'https://portal.azure.com',
    label: 'Azure Innovation Lab',
  },
  {
    url: 'https://console.cloud.google.com',
    label: 'GCP Innovation Lab',
  },
  {
    url: 'https://twodegrees1.sharepoint.com/teams/GlobalTechnologyTechnicalEnablement/SitePages/Cloud-Certifications-&-Vouchers.aspx',
    label: 'Cloud Certs & Vouchers',
  },
  {
    url: 'https://www.linkedin.com/learning/',
    label: 'LinkedIn Learning',
  },
  {
    url: 'https://app.pluralsight.com/',
    label: 'Pluralsight',
  },
  {
    url: 'https://slalom.com',
    label: 'Slalom Website',
  },
];
